import { render, staticRenderFns } from "./LeadView.vue?vue&type=template&id=3bc5c4e7"
import script from "./LeadView.vue?vue&type=script&lang=js"
export * from "./LeadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports